// extracted by mini-css-extract-plugin
module.exports = {"header-actions-component":"HeaderActions_header-actions-component__4aZh8","wrapper":"HeaderActions_wrapper__H3Fga"};